import script from "./AlbumView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumView.vue?vue&type=script&setup=true&lang=js"

import "./AlbumView.vue?vue&type=style&index=0&id=ee59a4fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee59a4fe"]])

export default __exports__